module.exports = __webpack_public_path__ + "static/media/proxy.2a6f80fb.png";